app.controller(
    'HelpController', ['$http', '$location', '$rootScope', '$scope', '$timeout', '$stateParams', 'HelpService', 'Upload', '$sce', '$state', 'TranslateService', HelpController]
);
function HelpController($http, $location, $rootScope, $scope, $timeout, $stateParams, HelpService, Upload, $sce, $state, TranslateService) {
    $scope.isAdmin = true;

    $scope.selectedItem = null;
    $scope.explorerModel = null;
    $scope.explorerPath = null;
    $scope.count = 0;
    $scope.progress = "";
    $scope.list = [
    ];
    $scope.langs = [
    ];
    $scope.files = [];

    $scope.sortType = ''; // set the default sort type
    $scope.sortReverse = false;  // set the default sort order
    $scope.showFolders = false;
    $scope.showLang = false;

    $scope.modalNewFolder = false;
    $scope.modalUpload = false;
    $scope.modalRename = false;
    $scope.modalEditNotes = false;

    $scope.folderName = null;
    $scope.uploadType = "";

    $scope.showOption = function (item, $event) {
        $event.stopPropagation();
        $scope.selectedItem = $scope.selectedItem === item ? null : item;
    };

    $scope.close = function () {
        if (!($scope.modalNewFolder || $scope.modalUpload || $scope.modalRename || $scope.modalEditNotes || $scope.modalPlayVideo))
            $scope.selectedItem = null;
    };

    $scope.showOptionLangs = function (item) {
        var current = item.option;
        angular.forEach($scope.langs, function (itm) {
            itm.option = false;
        });
        item.option = !current;
    };

    $scope.showOptionFiles = function (item) {
        var current = item.option;
        angular.forEach($scope.files, function (itm) {
            itm.option = false;
        });
        item.option = !current;
    };

    $scope.openFolder = function () {
        $scope.showFolders = true;
        $scope.showLang = false;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };

    $scope.openLang = function () {
        $scope.showLang = true;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };

    $scope.closeFolder = function () {
        $scope.showLang = false;
        $scope.showFolders = false;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };

    $scope.closeModalPlayVideo = function () {
        $scope.modalPlayVideo = false;
        let player = document.getElementById("videoPlayer");
        player.src = "";
    };

    $scope.openModalName = function (name) {
        if (name === 'new') {
            $scope.modalNewFolder = true;
            setTimeout(function () {
                angular.element('#modalNewFolderInput').focus();
            });
        } else if (name === 'uploadHelp') {
            $scope.uploadType = "help";
            $scope.modalUpload = true;
            $scope.files = [];
            $scope.progress = "";
        } else if (name === 'updateThumbnail') {
            $scope.uploadType = "thumbnail";
            $scope.modalUpload = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalUpload').focus();
            });
            console.log("test");
        }
        else if (name === 'rename') {
            $scope.modalRename = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalRenameInput').focus();
            });
        }
        else if (name === 'editNotes') {
            $scope.modalEditNotes = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalEditNotes').focus();
            });
        }
        else if (name === 'confirmDelete') {
            $scope.modalDelete = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalDelete').focus();
            });
        }
        else if (name === 'playVideo') {
            $scope.modalPlayVideo = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalPlayVideo').focus();
            });
        }
        return false;
    };

    $scope.addFolder = function (name) {
        $scope.explorerModel.itemList.unshift({ Name: name, Date: new Date(), Size: '0 B', Type: 'dir' });
    };

    $scope.addFolderModal = function (name) {
        name = name.trim();
        var path = name;
        if ($stateParams.path !== undefined && name !== '')
            path = $stateParams.path + "/" + name;

        if (path !== '') {
            HelpService.NewFolder(path)
                .then(function (message) {
                    $scope.addFolder(name);
                    $scope.modalNewFolder = false;
                    $scope.folderName = null;
                });
        }
    };

    // Call by confirm button of modalDelete
    $scope.deleteConfirmed = function (item) {
        $scope.deleteObject(item);
        $scope.modalDelete = false;
    };

    $scope.deleteObject = function (item) {
        var path = item.Name;
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + item.Name;

        HelpService.Delete(path)
            .then(function (model) {
                $scope.selectedItem = null;

                for (var i = $scope.explorerModel.itemList.length - 1; i >= 0; i--) {
                    if ($scope.explorerModel.itemList[i].Name === item.Name && $scope.explorerModel.itemList[i].IsFile === item.IsFile) {
                        $scope.explorerModel.itemList.splice(i, 1);
                    }
                }

                countResult();
            }
        );
    };

    $scope.confirmDelete = function (item, $event) {
        $event.stopPropagation();
        $scope.modalDelete = true;
        $scope.openModalName('confirmDelete');
    };

    $scope.rename = function (item, $event) {
        $event.stopPropagation();
        $scope.textEntered = item.Name;
        $scope.openModalName('rename');
    };


    $scope.updateThumbnail = function (item, $event) {
        $event.stopPropagation();
        $scope.textEntered = item.Name;
        $scope.openModalName('updateThumbnail');
        
    };



    $scope.renameFolder = function (item, newname) {
        var curName = item.Name;
        if ($stateParams.path !== undefined) {
            curName = $stateParams.path + "/" + item.Name;
            newname = $stateParams.path + "/" + newname;
        }

        if (curName && newname) {
            HelpService.Rename(curName, newname)
                .then(function (response) {
                    $timeout(function () {
                        $scope.result = response.data;
                        $scope.modalRename = false;
                        initController();
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                    console.log($scope.progress);
                });
        }
    };

    $scope.editNotes = function (item, $event) {
        $event.stopPropagation();
        $scope.modalEditNotes = true;
        $scope.notesEntered = item.Notes;
        $scope.openModalName('editNotes');
    };

    $scope.saveEditedNotes = function (item, content) {
        var simpleItem = {
            EncryptedPath: item.EncryptedPath,
            Notes: content
        };

        HelpService.SaveNotes(simpleItem)
            .then(function (response) {
                if (response.data === "True") {
                    // Saved successfully. Close the modal, reload the screen
                    $scope.modalEditNotes = false;
                    initController();
                } else {
                    // Saving fail. Inform the user to try again
                    console.log("Notes saving error!");
                }
            })
            ;
    };

    $scope.removeUploadFile = function (index) {
        $scope.files.splice(index, 1);
    };

    $scope.addUploadFilesByDragDrop = function (files) { $scope.addUploadFiles(files, true); };

    $scope.addUploadFiles = function (files, runApply) {
        if (files === undefined) { return; }
        $scope.files = [files[0]];

        if (runApply) { $scope.$apply(); }
    };

    $scope.isValidFileType = function (fileType) {
        if (typeof fileType !== "string") { return false; }

        let supportType = "";
        if ($scope.uploadType === "thumbnail")
            supportType = "image/jpeg, image/png";
        else
            supportType = "application/pdf, video/avi, video/flv, video/mp4', video/mov, video/webm, video/wmv";

        return supportType.indexOf(fileType) >= 0;
    };

    $scope.uploadFiles = function () {

        if ($scope.files && $scope.files.length) {

            // Filter valid files only
            let okFiles = [];
            $scope.files.forEach(file => {
                if ($scope.isValidFileType(file.type)) { okFiles.push(file); }
            });
            if (okFiles.length === 0) { return; }

            let service;
            if ($scope.uploadType === "help") {
                let path = "";
                if ($stateParams.path !== undefined) { path = $stateParams.path + "/"; }
                service = HelpService.UploadHelp(path, okFiles);
            }
            else {
                service = HelpService.UploadThumbnail($scope.selectedItem.EncryptedPath, okFiles);
            }

            service.then(
                function (response) {
                    $timeout(function () {
                        $scope.result = response.data;
                        $scope.modalUpload = false;
                        $scope.files = [];
                        initController();
                    });
                },
                function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                },
                function (evt) {
                    $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                }
            );
        }
    };

    $scope.download = function (item, $event) {
        $event.stopPropagation();

        var path = $stateParams.path ? $stateParams.path + "/" + item.Name : item.Name;

        HelpService
            .Download(path, "application/octet-stream")
            .then(function (response) {
                $scope.selectedItem = null;
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    //console.log(evt);
                    $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                    //console.log($scope.progress);
                }
            );
    };

    $scope.view = function (item, $event) {
        $event.stopPropagation();

        var path = $stateParams.path ? $stateParams.path + "/" + item.Name : item.Name;

        switch (item.Type) {
            case ".pdf":
                HelpService.Download(path, "application/pdf");
                break;
            case ".avi":
            case ".flv":
            case ".mov":
            case ".mp4":
            case ".webm":
            case ".wmv":
                HelpService.PlayVideo(path, item.Type.substring(1));
                $scope.openModalName('playVideo');
                break;
        }
    };

    $scope.goto = function (folder, mode) {
        var path = $stateParams.path ? $stateParams.path + "/" + folder : folder;
        var escapepath = path;
        
        $location.url("/help?path=" + escapepath + "&mode=" + mode);
    };

    function countResult() {
        $scope.count = $scope.explorerModel.itemList.length;
    }

    function load(path, search, sort, reverse) {
        HelpService.GetHelpIndex(path, search, sort, reverse)
            .then(function (model) {
                $scope.explorerModel = model.data;
                if (path !== "") {
                    var paths = path.split('/');
                    var js = [];
                    var curr = "";
                    for (var i = 0; i < paths.length; i++) {
                        if (curr !== "") {
                            curr += "/";
                        }
                        curr += paths[i];
                        let item = {};
                        item.path = curr;
                        item.name = paths[i];
                        js.push(item);
                    }
                    $scope.explorerPath = js;
                    $scope.files = js;
                }

                countResult();
            });
    }

    function initController() {
        TranslateService.use($rootScope.LangForInterface);

        if ($stateParams.path !== undefined)
            load($stateParams.path);
        else
            load("");
    }

    initController();

}